<script>
export let color = 'var(--blue)';
export let size = 44;
export let thickness = 3.6;
</script>

<style>
.base {
  display: inline-block;
}

.indeterminate {
  animation: circular-rotate 1.4s linear infinite;
}

.ani {
  animation: circular-dash 1.4s ease-in-out infinite;
  /* Some default value that looks fine waiting for the animation to kicks in. */
  stroke-dasharray: 80px, 200px;
    
  /* Add the unit to fix a Edge 16 and below bug. */
  stroke-dashoffset: 0px;
}

@keyframes circular-rotate {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

@keyframes circular-dash {
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
}
</style>

<div class="base indeterminate" style="width: {size}px;height: {size}px">
  <svg style="display: block" viewBox={`${size / 2} ${size / 2} ${size} ${size}`}>
    <circle class="ani" style="stroke: {color}"
      cx={size}
      cy={size}
      r={(size - thickness) / 2}
      fill="none"
      stroke-width={thickness}
    />
  </svg>
</div>